import {
	AddEmployeesContainer,
	SpecificEmployeeContainer,
} from '../../containers';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import { MimaButton, Modal, PageLoader } from '../../components';
import { toJS } from 'mobx';
import React from 'react';

const ViewEmployees = ({
	closeModal,
	loading,
	employees,
	addEmployee,
	showAddEmployee,
	specificEmployee,
	showSpecificEmployee,
}) => {
	return (
		<Modal closeModal={closeModal}>
			<>
				{!addEmployee && !specificEmployee && (
					<>
						<MimaButton title="Add Employee" onClick={showAddEmployee} />
						<div className={styles.employee__list}>
							{toJS(employees).map(employee => (
								<div key={employee.key}>
									<li onClick={() => showSpecificEmployee(employee.key)}>
										{employee.value}
									</li>
									<div className={styles.employee__list_line}></div>
								</div>
							))}
						</div>
					</>
				)}

				{addEmployee && <AddEmployeesContainer closeModal={closeModal} />}

				{specificEmployee && (
					<SpecificEmployeeContainer closeModal={closeModal} />
				)}
			</>
		</Modal>
	);
};

export default ViewEmployees;
